import React from 'react'
import { WithRouterProps } from 'react-router'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import BuyButtonContainer, {
  BuyButtonContainerProps,
} from '../BuyComponent/BuyButtonContainer'
import { FormattedMessage } from 'react-intl'
import {
  sendMetric,
  MetricAction,
  MetricShowcase,
} from '@/checkout-instore-legacy/VtexLakeHouse'

export type BuyNowButtonProps = BuyButtonContainerProps

export const BuyNowButton = withRouter(
  ({
    router,
    beforeAddToCart = () => {},
    ...props
  }: // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  BuyButtonContainerProps & WithRouterProps) => {
    const handleBeforeAddToCart = () => {
      sendMetric({
        action: MetricAction.QuickAddBuyNow,
        showcase: MetricShowcase.QuickAdd,
      })

      router.push('/cart')

      beforeAddToCart()
    }

    return (
      <BuyButtonContainer beforeAddToCart={handleBeforeAddToCart} {...props}>
        <FormattedMessage id="product.buy-now-button" />
      </BuyButtonContainer>
    )
  }
)
